import type { MessageTemplateProps } from "./MessageTemplate";
import MessageTemplate from "./MessageTemplate";
import { MessageTemplate400, MessageTemplate401, MessageTemplate403, MessageTemplate404, MessageTemplate405, MessageTemplate406, MessageTemplate407, MessageTemplate408, MessageTemplate409, MessageTemplate500, MessageTemplatePrimary, messageTemplateType } from "./MessageTemplateVariants";

export type { MessageTemplateProps };
export type { messageTemplateType };
export default MessageTemplate;
export { MessageTemplate400, MessageTemplate401, MessageTemplate403, MessageTemplate404, MessageTemplate405, MessageTemplate406, MessageTemplate407, MessageTemplate408, MessageTemplate409, MessageTemplate500, MessageTemplatePrimary};
